export default __webpack_public_path__ + "static/media/US.39ae252a.svg";